import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	InputAdornment,
	IconButton,
	FormControl,
	InputLabel,
	Input,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
// import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilledInput from "@mui/material/FilledInput";
import SearchIcon from "@mui/icons-material/Search";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import { countries } from "../../utils/countriesDropdown";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getKycReportList } from "../../redux/actions/getKycReportListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import { dealerGetListDsrMaster } from "../../redux/actions/dealerGetListDsrMasterAction";
import { getWalletTransactionList } from "../../redux/actions/getWalletTransactionListAction";
import { dealerChangeDsrMasterPassword } from "../../redux/actions/dealerChangeDsrMasterPasswordAction";
import { dealerBlockDsrMaster } from "../../redux/actions/dealerBlockDsrMasterAction";
import SOLogout from "../../components/Logout/SOLogout";
import FileBase64 from "../../components/Upload/UploadFile";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { dealerAddUpdateDivisonList } from "../../redux/actions/dealerAddUpdateDivisionListAction";
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from "../../redux/actions/dealerAddUpdateThanaListAction";
import { dealerAddUpdateUnionList } from "../../redux/actions/dealerAddUpdateUnionListAction";
import { dealerAddOrUpdateDsrList } from "../../redux/actions/dealerAddOrUpdateDsrListAction";
import { dealerViewDsrList, resetDealerViewDsrList } from "../../redux/actions/dealerViewDsrListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import {useTheme} from '@mui/material'
import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";

const useStyles = makeStyles(() => ({
	table: {
		minWidth: 650
	},
	margin: {
		margin: useTheme().spacing(1)
	},
	root: {
		display: "flex",
		flexWrap: "wrap"
	},
	textField: {
		width: "25ch"
	}
}));

function DealerDsrMaster() {
	useEffect(() => {
		dispatch(resetDealerViewDsrList());
	}, []);
	// const [values, setValues] = React.useState({

	//     newPassword: '',

	//     showPassword: false,
	// });
	// const [confirmPass, setConfirmPass] = React.useState({

	//     confirmPassword: '',

	//     showConfirmPassword: false,
	// });
	// const handleClickShowPassword = () => {
	//     setValues({ ...values, showPassword: !values.showPassword });
	// };
	// const handleClickShowConfirmPassword = () => {
	//     setConfirmPass({ ...confirmPass, showConfirmPassword: !confirmPass.showConfirmPassword });
	// };

	// const handleChange = (prop) => (event) => {
	//     setValues({ ...values, [prop]: event.target.value });
	//     setConfirmPass({ ...confirmPass, [prop]: event.target.value })
	// };

	// const handleMouseDownPassword = (event) => {
	//     event.preventDefault();
	// };
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	// const [editOpen, setEditOpen] = React.useState(false);
	const [btnAction, setbBtnAction] = useState("");

	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [pageToggle, setPageToggle] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [editOpenDsr, setEditOpenDsr] = React.useState(false);

	const navigate = useHistory();
	const [accountStatus, setAccountStatus] = useState("All");

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getDsrMasterListStatus, setGetDsrMasterListStatus] = useState(false);
	const [getDsrMasterListArray, setGetDsrMasterListArray] = useState([]);

	const [getKycReportListStatus, setGetKycReportListStatus] = useState(false);
	const [getKycReportListArray, setGetKycReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);
	const [
		getChangeDsrMasterPasswordStatus,
		setGetChangeDsrMasterPasswordStatus
	] = useState(false);
	const [getChangeDsrMasterPasswordArray, setGetChangeDsrMasterPasswordArray] =
		useState([]);
	const [blockDsrMasterStatus, setBlockDsrMasterStatus] = useState(false);
	const [blockDsrMasterArray, setBlockDsrMasterArray] = useState([]);

	const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] =
		useState(false);
	const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] =
		useState([]);

	const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] =
		useState(false);
	const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] =
		useState([]);

	const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] =
		useState(false);
	const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState(
		[]
	);

	const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] =
		useState(false);
	const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState(
		[]
	);

	const [getEditDsrListRes, setGetEditDsrListRes] =
		useState("");
	const [getEditDsrListResStatus, setGetEditDsrListResStatus] =
		useState(false);


	const [updateUserInformationStatus, setUpdateUserInformationStatus] =
		useState(false);
	const [updateUserInformationPopup, setUpdateUserInformationPopup] = useState(
		[]
	);

	//update user information
	const [mobNumber, setMobNumber] = useState("");
	const [getPassword, setGetPassword] = useState("");
	const [getConfirmPassword, setGetConfirmPassword] = useState("");
	const [getRole, setGetRole] = useState("");
	const [getFullName, setGetFullName] = useState("");
	const [getFirstName, setGetFirstName] = useState("");
	const [getMotherName, setGetMotherName] = useState("");
	const [getLastName, setGetLastName] = useState("");
	const [getFatherName, setGetFatherName] = useState("");
	const [getId, setGetId] = useState("");
	const [getIdNumber, setGetIdNumber] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [getAddress, setGetAddress] = useState("");
	const [editCountry, setEditCountry] = useState("");
	const [editDivision, setEditDivision] = useState("");
	const [editDistrict, setEditDistrict] = useState("");
	const [editThana, setEditThana] = useState("");
	const [editUnion, setEditUnion] = useState("");
	const [custId, setCustId] = useState("");

	// const [customerID, setCustomerID] = useState("")

	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getDsrMasterList = useSelector(
		({ dealerGetListDsrMaster }) => dealerGetListDsrMaster
	);
	const getChangeDsrMasterPasswordList = useSelector(
		({ dealerChangeDsrMasterPassword }) => dealerChangeDsrMasterPassword
	);
	const EditDsrDeatilsRes = useSelector(
		({ dealerViewDsrList }) => dealerViewDsrList
	);
	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getKycReportListRes = useSelector(
		({ getKycReportList }) => getKycReportList
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);
	const blockDsrMasterRes = useSelector(
		({ dealerBlockDsrMaster }) => dealerBlockDsrMaster
	);

	const setDivisionList = useSelector(
		({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
	);
	const setDistrictList = useSelector(
		({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
	);

	const setThanaList = useSelector(
		({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
	);

	const setUnionList = useSelector(
		({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
	);

	const setAddOrUpdateDsrList = useSelector(
		({ dealerAddOrUpdateDsrLists }) => dealerAddOrUpdateDsrLists
	);

	//edit password
	const editPassword = "editPassword";
	const [editPassOpen, setEditPassOpen] = React.useState(false);
	const [userEditPass, setUserEditPass] = useState({
		newPassword: "",
		confirmPassword: "",
		change: "change"
	});
	const [changePassword, setChangePassword] = useState(true);
	const handleClickShowPassword = () => {
		setChangePassword(!changePassword);
	};
	const [confirmPass, setConfirmPassword] = useState(true);
	const handleClickConfirmShowPassword = () => {
		setConfirmPassword(!confirmPass);
	};
	// const changeIcon = changePassword === true ? false : true;

	// const changeIconConfirm = confirmPass === true ? false : true;

	const { newPassword, confirmPassword, change } = userEditPass;

	const [customerID, setCustomerID] = useState("");
	const [isAccountLocked, setIsAccountLocked] = useState("");

	const setEditPassData = (row, fs) => {
		if (fs == "editPassword") {
			setEditPassOpen(true);
		}
		setUserEditPass({
			newPassword: row.newPassword,
			confirmPassword: row.confirmPassword
		});
		setCustomerID(row.customerId);
	};

	const handleClose1 = () => {
		setEditPassOpen(false);
		// setUserEditPass({
		//     userMobileNumber: "",
		//     userRole: "",
		//     userFullName: "",
		//     userMotherName: "",
		//     userFatherName: "",
		//     userUploadProfilePic: "",
		//     userIdType: "",
		//     userIdNumber: "",
		//     userNIDFront: "",
		//     userNIDBack: "",
		//     currency: "",
		//     userAddress: "",
		//     country: "",
		//     division: "",
		//     district: "",
		//     thanaUpazilla: "",
		//     unionWard: ""
		// });
	};
	//block dsr
	const blockDsr = "blockDsr";
	const [notificationBlockDsrOpen, SetnotificationBlockDsrOpen] =
		React.useState(false);

	const [openBlockdsr, setOpenBlockDsr] = React.useState(false);
	const [openUnBlockdsr, setOpenUnBlockDsr] = React.useState(false);

	// const setBlockDsrData = (row, fs) => {
	//     if (fs == "blockDsr") {
	//         setOpenBlockDsr(true);
	//     }
	//     setCustomerID(row.customerId)

	// }

	const BlockDsrDataFunc = (customerId, isAccountLocked) => {
		setCustomerID(customerId);
		setIsAccountLocked(isAccountLocked);
		setIsAccountLocked("0");
		setOpenBlockDsr(true);
	};
	const UnBlockDsrDataFunc = (customerId, isAccountLocked) => {
		setCustomerID(customerId);
		setIsAccountLocked(isAccountLocked);
		setIsAccountLocked("1");
		// setOpenBlockDsr(true);
		setOpenUnBlockDsr(true)
	};

	//update user information
	const edit = "edit";

	const [updateUserDetailStatus, setUpdateUserDetailStatus] = useState(false);
	const [updateUserDetailArray, setUpdateUserDetailArray] = useState("");
	const [notificationOpenModal, setNotificationOpenModal] = useState(false);
	const [notificationOpen, setNotificationOpen] = useState(false);

	const [uploadPhoto, setUploadPhoto] = useState("");
	const [uploadPhotoName, setUploadPhotoName] = useState("");
	const [nidFronts, setNidFronts] = useState("");
	const [nidFrontsName, setNidFrontsName] = useState("");

	const [nidBacks, setNidBacks] = useState("");
	const [nidBacksName, setNidBacksName] = useState("");
	const handleAttachmentsDoc = (e, nidFronts) => {
		if (nidFronts == "nidFronts") {
			setNidFronts(e.base64);
			setNidFrontsName(e.name);
		} else if (nidFronts == "nidBacks") {
			setNidBacks(e.base64);
			setNidBacksName(e.name);
		} else if (nidFronts == "uploadPhoto") {
			setUploadPhoto(e.base64);
			setUploadPhotoName(e.name);
		}
	};


	const handleClose = () => {
		if (editOpenDsr) {
			setEditOpenDsr(false)
		}
		setOpen(false);
		setOpenBlockDsr(false);
		setOpenUnBlockDsr(false)
		setCustId()
		// setEditOpen(false);
	};

	// const [getStatus, setGetStatus] = useState("All")
	const [user, setUser] = useState({
		userMobNumber: "",
		userName: "",
		userId: "",
		getStatus: "",
		customerId: "",
		// verificationId: "",
		walletOwnerId: "",
		parentId: "",
		// verificationStatus: "",
		accountStatus: "",
		action: "",
		role: ""
	});

	const {
		userMobNumber,
		userName,
		userId,
		getStatus,
		// status,
		// customerId,
		verificationId,
		walletOwnerId,
		parentId,
		verificationStatus,
		action,
		role
	} = user;

	const handleChange = ({ target: { name, value } }) => {
		if (name === "EditMobNumber") {
			Util.verifyMobile(value) ? setMobNumber(value) : setMobNumber(mobNumber);
		}
		if (name === "EditPassword") {
			setGetPassword(value);
		}
		if (name === "GetConfirmPassword") {
			setGetConfirmPassword(value);
		}

		if (name === "Role") {
			setGetRole(value);
		}
		if (name === "FullName") {
			Util.verifyAlphabet(value)
				? setGetFullName(value)
				: setGetFullName(getFullName);
		}
		if (name === "FirstName") {
			Util.verifyAlphabet(value)
				? setGetFirstName(value)
				: setGetFirstName(getFirstName);
		}
		if (name === "LastName") {
			Util.verifyAlphabet(value)
				? setGetLastName(value)
				: setGetLastName(getLastName);
		}
		if (name === "MotherName") {
			Util.verifyAlphabet(value)
				? setGetMotherName(value)
				: setGetMotherName(getMotherName);
		}
		if (name === "FatherName") {
			Util.verifyAlphabet(value)
				? setGetFatherName(value)
				: setGetFatherName(getFatherName);
		}
		if (name === "IDType") {
			Util.verifyAlphabet(value) ? setGetId(value) : setGetId(getId);
		}
		if (name === "IDNumber") {
			Util.verifyMobile(value)
				? setGetIdNumber(value)
				: setGetIdNumber(getIdNumber);
		}

		if (name === "EditCurrency") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditCurrency(value);
		}
		if (name === "GetAddress") {
			Util.alphaNumeric(value)
				? setGetAddress(value)
				: setGetAddress(getAddress);
		}
		if (name === "EditCountry") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditCountry(value == "Select Country" ? "" : value);
		}
		if (name === "EditDivision") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditDivision(value == "Select Division" ? "" : value);
		}
		if (name === "EditDistrict") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditDistrict(value == "Select District" ? "" : value);
		}
		if (name === "EditThana") {
			setEditThana(value == "Select Thana" ? "" : value);
		}
		if (name === "EditUnion") {
			setEditUnion(value == "Select Union" ? "" : value);
		}
		// if (name === "getStatus") {
		// 	setGetStatus(value);
		// }
	};

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user,
			// ...user1,
			...userEditPass
			// ...customerID
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
		// setUser1(obj);
		setUserEditPass(obj);
		// setCustomerID(obj)
	};
	const getDsrMasterListReq = () => {
		setIsLoading(true);

		setGetDsrMasterListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				dsrNumber: userMobNumber,
				dsrName: userName,
				dsrId: userId,

				status: getStatus === 'All' ? '' : getStatus,
				// status: type == "block" ? 0 : 1
			}
		};
		dispatch(dealerGetListDsrMaster(req, authToken));
	};

	const getDsrMasterListFunc = () => {
		if (getDsrMasterListStatus) {
			if (getDsrMasterList.data.status == "success") {
				setIsLoading(false);

				setGetDsrMasterListArray([].concat(getDsrMasterList.data.dsrList));

			}
			if (getDsrMasterList.data.status == "failed") {
				setIsLoading(false);

				setGetDsrMasterListArray(getDsrMasterList.data);
				if (
					getDsrMasterList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getDsrMasterList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};




	useEffect(() => {
		getDsrMasterListFunc();
	}, [getDsrMasterList.data.status]);

	useEffect(() => {
		if (getDsrMasterList.data.status == "success") {
			setPage(0);
		}
	}, [getDsrMasterList.data.status]);




	const updateEditHandleClick = (customerId, Edit) => {
		setbBtnAction(Edit);
		EditDsrListView(customerId)
		setEditOpenDsr(true);
		setCustomerID(customerId);
		setGetEditDsrListResStatus(true)
		setCustId(customerId);
	}

	const EditDsrListView = (customerId) => {
		setGetEditDsrListResStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				custId: customerId
			}
		}
		dispatch(
			dealerViewDsrList(req, authToken)
		);
	}

	useEffect(() => {
		if (getEditDsrListResStatus) {
			// setEditOpen(false);
			if (EditDsrDeatilsRes.data.status == "success") {
				setEditOpenDsr(true)
				setMobNumber(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.contact
				);
				setGetRole(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.role
				);
				setGetFirstName(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.firstName

				);
				setGetFullName(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.fullName

				);
				setGetLastName(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.lastName

				);
				setGetMotherName(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.motherName

				);
				setGetFatherName(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.fatherName

				);
				setGetId(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.idType

				);
				setGetIdNumber(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.idNumber

				);
				setEditCurrency(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.currency

				);
				setGetAddress(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.address

				);
				setEditCountry(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.country

				);
				setEditDivision(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.division

				);
				setEditDistrict(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.district

				);
				setEditThana(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.thana

				);
				// console.log("editThanass", EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.thana)
				setEditUnion(
					EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.union

				);
				// console.log("unionss", EditDsrDeatilsRes.data.actionCustomerMasterResponseVO1.union)

				setGetEditDsrListRes(EditDsrDeatilsRes.data);
				setNidBacks(EditDsrDeatilsRes.data.userMaster.base64UserPhotoBack)
				setNidBacksName(EditDsrDeatilsRes.data.userMaster.userPhotoIdBackFileName);
				setNidFronts(EditDsrDeatilsRes.data.userMaster.base64UserPhotoFront)
				setNidFrontsName(EditDsrDeatilsRes.data.userMaster.userPhotoIdFileName)


			}
			if (EditDsrDeatilsRes.data.status == "Failed") {
				setGetEditDsrListRes(EditDsrDeatilsRes.data);
				if (
					EditDsrDeatilsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					EditDsrDeatilsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (EditDsrDeatilsRes.data.status == "failed") {
				setGetEditDsrListRes(EditDsrDeatilsRes.data);
				if (
					EditDsrDeatilsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					EditDsrDeatilsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (EditDsrDeatilsRes.data.status == "Not Found") {
				setGetEditDsrListRes(EditDsrDeatilsRes.data);
			}
		}
	}, [EditDsrDeatilsRes.data.status])


	// const handleChange = ({ target: { name, value } }) => {
	//     if (name === "customerId") {
	//         // setVerificationId(value);
	//         Util.verifyNumber(value) ? setCustomerId(value) : setCustomerId(customerId);
	//     }

	//     if (name === "accountStatus") {
	//         setAccountStatus(value);
	//     }

	//     // if (name === "role") {
	//     //     // setRole(value);
	//     //     setupdateUserRole(value == "All" ? "" : value);
	//     //   }

	// };

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};
	const handleNoticationClose = () => {
		setNotificationOpenModal(false);
		SetnotificationBlockDsrOpen(false);
		setNotificationOpen(false);
		setEditOpenDsr(false)

	};
	const updateDetailsCustomerFunc = () => {
		setUpdateUserInformationStatus(true);
		// setOpen(false);
		setNotificationOpenModal(false);

		const Req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				phoneNo: mobNumber,
				password: getPassword,
				custId: custId,
				firstName: getFirstName,
				lastName: getLastName,
				fullName: getFullName,
				address: getAddress,
				country: editCountry.split("-")[0],
				role: getRole,
				currency: editCurrency,
				// countryCode: getCountryCode,
				division: editDivision,
				district: editDistrict,
				thana: editThana,
				union: editUnion,
				fatherName: getFatherName,
				motherName: getMotherName,
				// profilePic: "",
				// uploadNIDFront: "",
				// uploadNIDBack: ""
				profilePic: uploadPhoto.split(",")[1] || "",
				uploadNIDFront: nidFronts.split(",")[1] || "",
				uploadNIDBack: nidBacks.split(",")[1] || "",
				// profilePic: uploadPhoto,
				// uploadNIDFront: nidFronts,
				// uploadNIDBack: nidBacks,
			}

		};
		// console.log("updatedata", Req)
		dispatch(dealerAddOrUpdateDsrList(Req, authToken));
		setEditOpenDsr(false)
	};
	// useEffect( () =>{
	// 	if(updateUserInformationStatus){

	// 	}
	// })

	const UpdateUserInformation = () => {
		if (updateUserInformationStatus) {
			if (setAddOrUpdateDsrList.data.status == "success") {
				setOpen(false);
				setUpdateUserInformationPopup(setAddOrUpdateDsrList.data);
				setNotificationOpenModal(true);
				getDsrMasterListReq()


			}
			if (setAddOrUpdateDsrList.data.status == "failed") {
				setOpen(false);
				setUpdateUserInformationPopup(setAddOrUpdateDsrList.data);
				setNotificationOpenModal(true);
				if (
					setAddOrUpdateDsrList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setAddOrUpdateDsrList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (setAddOrUpdateDsrList.data.status == "Failed") {
				setOpen(false);
				setUpdateUserInformationPopup(setAddOrUpdateDsrList.data);
				setNotificationOpenModal(true);
				if (
					setAddOrUpdateDsrList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setAddOrUpdateDsrList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		UpdateUserInformation();
	}, [setAddOrUpdateDsrList.data.status]);

	const AddUpdateDivisionListFunc = () => {
		if (setAddUpdateDivisionListStatus) {
			if (setDivisionList.data.status == "success") {
				setSetAddUpdateDivisionListArray(setDivisionList.data.list);
			}
			if (setDivisionList.data.status == "failed") {
				setSetAddUpdateDivisionListArray(setDivisionList.data);
				if (
					setDivisionList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setDivisionList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const setAddUpdateDivisionListReq = () => {
		setSetAddUpdateDivisionListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId
			}
		};
		dispatch(dealerAddUpdateDivisonList(req, authToken));
	};

	useEffect(() => {
		AddUpdateDivisionListFunc();
	}, [setDivisionList.data.status]);

	// useEffect(() => {
	//     setAddUpdateDivisionListReq()
	// }, [])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setAddUpdateDivisionListReq();
			getDsrMasterListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const AddUpdateDistrictListFunc = () => {
		if (setAddUpdateDistrictListStatus) {
			if (setDistrictList.data.status == "success") {
				setSetAddUpdateDistrictListArray(setDistrictList.data.list);
			}
			if (setDistrictList.data.status == "failed") {
				setSetAddUpdateDistrictListArray(setDistrictList.data);
				if (
					setDistrictList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setDistrictList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const setAddUpdateDistrictListReq = () => {
		setSetAddUpdateDistrictListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDivision
			}
		};
		dispatch(dealerAddUpdateDistrictList(req, authToken));
	};
	useEffect(() => {
		if (editDivision) {
			setAddUpdateDistrictListReq()
		}
	}, [editDivision])
	useEffect(() => {
		AddUpdateDistrictListFunc()
	}, [setDistrictList.data.status])

	// useEffect(() => {
	// 	setAddUpdateDistrictListReq();
	// }, [editDivision]);

	// useEffect(() => {
	// 	AddUpdateDistrictListFunc();
	// }, [setDistrictList.data.status]);

	const AddUpdateThanaListFunc = () => {
		if (setAddUpdateThanaListStatus) {
			if (setThanaList.data.status == "success") {
				setSetAddUpdateThanaListArray(setThanaList.data.list);
			}
			if (setThanaList.data.status == "failed") {
				setSetAddUpdateThanaListArray(setThanaList.data);
				if (
					setThanaList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setThanaList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const setAddUpdateThanaListReq = () => {
		setSetAddUpdateThanaListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDistrict
			}
		};
		dispatch(dealerAddUpdateThanaList(req, authToken));
	};

	// useEffect(() => {
	// 	setAddUpdateThanaListReq();
	// }, [editDivision]);

	useEffect(() => {
		if (editDistrict) {
			setAddUpdateThanaListReq()
		}
	}, [editDistrict])

	useEffect(() => {
		AddUpdateThanaListFunc();
	}, [setThanaList.data.status]);

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		setAddUpdateThanaListReq();

	// 	}

	// }, [editDivision])
	// useEffect(() => {
	// 	AddUpdateThanaListFunc();
	// }, [setThanaList.data.status]);

	const AddUpdateUnionListFunc = () => {
		if (setAddUpdateUnionListStatus) {
			if (setUnionList.data.status == "success") {
				setSetAddUpdateUnionListArray(setUnionList.data.list);
			}
			if (setUnionList.data.status == "failed") {
				setSetAddUpdateUnionListArray(setUnionList.data);
				if (
					setUnionList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setUnionList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const setAddUpdateUnionListReq = () => {
		setSetAddUpdateUnionListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				district: editDistrict,
				thana: editThana
			}
		};
		dispatch(dealerAddUpdateUnionList(req, authToken));
	};
	useEffect(() => {
		setAddUpdateUnionListReq()
	}, [editDivision, editThana])

	useEffect(() => {
		AddUpdateUnionListFunc();
	}, [setUnionList.data.status]);
	// useEffect(() => {
	// 	setAddUpdateUnionListReq();
	// }, [editDivision, editThana]);

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		setAddUpdateUnionListReq();

	// 	}
	// }, [editDivision, editThana])
	// useEffect(() => {
	// 	AddUpdateUnionListFunc();
	// }, [setUnionList.data.status]);

	const setChangeDsrMasterPasswordReq = () => {
		setGetChangeDsrMasterPasswordStatus(true);

		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				custId: customerID,
				confirmPassword: confirmPassword,
				newPassword: newPassword,
				action: "change"
			}
		};
		dispatch(dealerChangeDsrMasterPassword(req, authToken));
		setEditPassOpen(false)
		// setEditPassOpen(true);
	};
	const setChangeMasterPassword = () => {
		setChangeDsrMasterPasswordReq();
	};

	const blockDsrMasterRecords = () => {
		setBlockDsrMasterStatus(true);
		setOpenBlockDsr(false);
		setOpenUnBlockDsr(false)
		const req = {
			actionCustomerMasterRequestVO: {
				action: "block",
				isAccountLocked: isAccountLocked,
				custId: customerID,
				dealerId: partnerloginUser.data.partnerId
			}
		};
		dispatch(dealerBlockDsrMaster(req, authToken));
		// setEditPassOpen(true);
	};
	const blockDsrMasterResFunc = () => {
		if (blockDsrMasterStatus) {
			if (blockDsrMasterRes.data.status == "success") {
				setBlockDsrMasterArray(blockDsrMasterRes.data);

				SetnotificationBlockDsrOpen(true);
				getDsrMasterListReq()


			}
			if (blockDsrMasterRes.data.status == "Failed") {
				setBlockDsrMasterArray(blockDsrMasterRes.data);
				SetnotificationBlockDsrOpen(true);
				if (
					blockDsrMasterRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockDsrMasterRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (blockDsrMasterRes.data.status == "failed") {
				setBlockDsrMasterArray(blockDsrMasterRes.data);
				SetnotificationBlockDsrOpen(true);
				if (
					blockDsrMasterRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockDsrMasterRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		blockDsrMasterResFunc();
	}, [blockDsrMasterRes.data.status]);




	const getChangeDsrMasterPasswordFunc = () => {
		if (getChangeDsrMasterPasswordStatus) {
			if (getChangeDsrMasterPasswordList.data.status == "success") {
				setGetChangeDsrMasterPasswordArray(getChangeDsrMasterPasswordList.data);
				setNotificationOpen(true);
				setEditPassOpen(false);
			}
			if (getChangeDsrMasterPasswordList.data.status == "failed") {
				setGetChangeDsrMasterPasswordArray(getChangeDsrMasterPasswordList.data);
				setNotificationOpen(true);
				setEditPassOpen(false);
				if (
					getChangeDsrMasterPasswordList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getChangeDsrMasterPasswordList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getChangeDsrMasterPasswordList.data.status == "Failed") {
				// setOpen(false);
				setGetChangeDsrMasterPasswordArray(getChangeDsrMasterPasswordList.data);
				setNotificationOpen(true);
				setEditPassOpen(false);
				if (
					getChangeDsrMasterPasswordList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getChangeDsrMasterPasswordList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};



	useEffect(() => {
		getChangeDsrMasterPasswordFunc();
	}, [getChangeDsrMasterPasswordList.data.status]);



	useEffect(() => {
		if (getWalletTransactionListStatus) {
			getWalletTransactionListFun();
		}
	}, [getWalletTransactionListRes.data.status]);

	const getWalletTransactionListFun = () => {
		if (getWalletTransactionListRes.data.status == "success") {
			setGetWalletTransactionListArray(
				[].concat(getWalletTransactionListRes.data.transactionList)
			);
		}
		if (getWalletTransactionListRes.data.status == "failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "Failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "NOT FOUND") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
		}
	};
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {

			getDsrMasterListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};


	const sendCustomerId = (id, customerId) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/DealerViewDsrList`,
			state: { param1: `${id}`, param2: `${customerId}` }
		});
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid container style={{ padding: "25px", justifyContent: "right" }}>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={2}>
							<NavLink to="/index/DealerAddNewUser">
								<CustomButton
									style={{
										padding: "8px",
										margin: "0 8px"
									}}
								>
									Add New User
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={3} sm={12} xs={12} lg={2}>
							<NavLink to="/index/DealerAddLimit">
								<CustomButton
									style={{
										padding: "8px",
										margin: "0 8px"
									}}
								>
									Add Limit
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="User Mob Number"
								fullWidth={true}
								name="userMobNumber"
								value={userMobNumber}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="User Name"
								fullWidth={true}
								name="userName"
								value={userName}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="User Id"
								fullWidth={true}
								name="userId"
								value={userId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								// id="name"
								label="Status"
								type="name"
								fullWidth
								variant="standard"
								name="getStatus"
								// value={getStatus || ""}
								defaultValue={getStatus || "All"}
								// onChange={handleChange}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="All" selected="">
									All
								</MenuItem>
								<MenuItem value="0">Block</MenuItem>
								<MenuItem value="1">Unblock</MenuItem>

							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>

							<CustomButton
								style={{
									padding: "8px",
									margin: "8px 8px"
								}}
								variant="contained"
								onClick={getDsrMasterListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getDsrMasterListArray.length == undefined ||
					!getDsrMasterListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										{/* <TableHead>
                                            <TableRow style={{ background: "#00b9f5" }}>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Customer Id{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Customer Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Language
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mobile Number
                                                </TableCell>
                                            </TableRow>
                                        </TableHead> */}
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Customer Id{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													User Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													User Mobile No
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													NID Number{" "}
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Account Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{getDsrMasterListArray &&
												[]
													.concat(getDsrMasterListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell
																align="center"
																style={{
																	marginTop: "1rem",
																	// marginLeft: "rem",
																	// color: "#00b9f5",
																	cursor: "pointer",
																	fontWeight: "600"
																}}
																className="themeColor"
															>
																<span
																	onClick={() => sendCustomerId(row.customerId)}
																>
																	{row.customerId}
																</span>
															</TableCell>
															<TableCell align="center">
																{row.customerName}
															</TableCell>
															<TableCell align="center">
																{row.mobNumber}
															</TableCell>
															<TableCell align="center">
																{row.language}
															</TableCell>

															{/* <TableCell align="center">{row.verifyStatus}</TableCell> */}
															<TableCell align="center">{row.accountStatus}</TableCell>

															<TableCell align="center">
																<Tooltip title="Edit">
																	<CustomButton
																		style={{
																			padding: "8px"
																		}}

																		onClick={() =>
																			updateEditHandleClick(row.customerId, "Edit")
																		}
																	// onClick={() =>
																	// 	editUserInformation(
																	// 		row.mobNumber,
																	// 		row.customerName,
																	// 		row.role,
																	// 		row.currency,
																	// 		// row.IdType,
																	// 		// row.IdNumber,
																	// 		row.country,
																	// 		row.division,
																	// 		row.district,
																	// 		row.union,
																	// 		row.thana,
																	// 		row.customerId
																	// 	)
																	// }

																	>
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	</CustomButton>
																</Tooltip>

																<Tooltip title="Edit Pass">
																	<CustomButton
																		style={{
																			padding: "10px"
																		}}
																		onClick={() =>
																			setEditPassData(row, editPassword)
																		}

																	// onClick={() =>
																	//     handleClickBlockFunc(row.customerId)
																	// }
																	>
																		Edit Pass
																	</CustomButton>
																</Tooltip>
																{/* <TableCell align="center">{row.isAccountLocked}</TableCell> */}
																{/* {row.isAccountLocked == "0" ? (
																	<>
																		<TableCell align="center">
																			<CustomButton
																				style={{
																					padding: "10px"
																				}}
																				onClick={() =>
																					BlockDsrDataFunc(
																						row.customerId,
																						row.isAccountLocked
																						"Block"
																					)
																				}


																			>
																				Block

																			</CustomButton>

																		</TableCell>
																	</>
																) : (
																	<Tooltip title="Unblock">

																		<CustomButton
																			style={{
																				padding: "10px"
																			}}

																			onClick={() =>
																				UnBlockDsrDataFunc(
																					row.customerId,
																					row.isAccountLocked,
																					"Unblock"
																				)
																			}


																		>
																			Unblock

																		</CustomButton>
																	</Tooltip>
																) */}
																{/* } */}
																<Tooltip title="Unblock">
																	{row.isAccountLocked == "0" ? (
																		<CustomButton
																			style={{
																				padding: "10px"
																			}}
																			onClick={() =>
																				BlockDsrDataFunc(
																					row.customerId,
																					row.isAccountLocked,
																					"Block"
																				)
																			}


																		>
																			Unblock

																		</CustomButton>
																	) : (
																		<Tooltip title="Block">

																			<CustomButton
																				style={{
																					padding: "10px"
																				}}

																				onClick={() =>
																					UnBlockDsrDataFunc(
																						row.customerId,
																						row.isAccountLocked,
																						"Unblock"
																					)
																				}


																			>
																				Block

																			</CustomButton>
																		/</Tooltip>

																	)}
																</Tooltip>
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getDsrMasterListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
				{btnAction == "Edit" && (
					<div>
						<Dialog open={editOpenDsr} onClose={handleClose}>
							<DialogTitle>User Information</DialogTitle>
							<DialogContent>
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									required
									helperText="(Please Enter Valid Mobile Number)"
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									autoFocus
									// margin="dense"
									label="Mobile Number"
									type="text"
									name="EditMobNumber"
									fullWidth={true}
									variant="standard"
									value={mobNumber || ""}
									onChange={handleChange}
									disabled

								// onChange={handleUpdateChange}
								/>

								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									select
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Role"
									fullWidth={true}
									name="Role"
									value={getRole || ""}
									onChange={handleChange}

								// onChange={handleUpdateChange}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="DSR">DSR</MenuItem>
								</TextField>
								{/* <MenuItem value="DSR">DSR</MenuItem> */}

								{/* <TextField
                                select
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Status"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="statusType"
                                value={statusType || ""}
                                onChange={handleChange}
                            >
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Closed">Closed</MenuItem>
                            </TextField> */}
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}
								<TextField
									required
									// onChange={(e) => onInputChange(e, "alphabet")}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									type="text"
									label="First Name"
									fullWidth={true}
									name="FirstName"
									onChange={handleChange}
									value={getFirstName || ""}
								></TextField>

								<TextField
									required
									// onChange={(e) => onInputChange(e, "alphabet")}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									type="text"
									label="Full Name"
									fullWidth={true}
									name="FullName"
									onChange={handleChange}
									value={getFullName || ""}
								></TextField>
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}
								<TextField
									required
									// onChange={(e) => onInputChange(e, "alphabet")}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									type="text"
									label="Last Name"
									fullWidth={true}
									name="LastName"
									onChange={handleChange}
									value={getLastName || ""}
								></TextField>
								<TextField
									required
									// onChange={(e) => onInputChange(e, "alphabet")}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									type="text"
									label="Mother Name"
									fullWidth={true}
									name="MotherName"
									onChange={handleChange}
									value={getMotherName || ""}
								></TextField>
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									required
									// onChange={(e) => onInputChange(e, "alphabet")}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									type="text"
									label="Father Name"
									fullWidth={true}
									name="FatherName"
									onChange={handleChange}
									value={getFatherName || ""}
								></TextField>
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d", marginTop: "10px" }}
								>
									Upload Photo
								</Typography>
								{/* <input
                  name="photo"
                  value={photo}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard2"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadPhoto")}
									showUploadList={false}
									value={uploadPhotoName}
									style={{ marginTop: "10px" }}
								/>
								{uploadPhotoName ? uploadPhotoName : ""}

								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="ID TYPE"
									fullWidth={true}
									name="IDType"
									style={{ marginTop: "10px" }}
									value={getId}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "alphabet")}
								/>

								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									size="small"
									color="primary"
									autoFocus={true}
									label="ID Number"
									fullWidth={true}
									name="IDNumber"
									style={{ marginTop: "10px" }}
									value={getIdNumber}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e, "number")}
								/>
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d", marginTop: "10px" }}
								>
									Upload NID Front
								</Typography>
								{/* <input
                  name="nidFront"
                  value={nidFront}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidFronts")}
									showUploadList={false}
									value={nidFrontsName}
									style={{ marginTop: "10px" }}
								/>
								{nidFrontsName ? nidFrontsName : ""}
								{/* </div> */}

								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d", marginTop: "10px" }}
								>
									Upload NID Back
								</Typography>
								{/* <input
                  name="nidback"
                  value={nidBack}
                  className="my-2"
                  type="file"
                  placeholder="Browse"
                  onChange={(e) => onInputChange(e)}
                /> */}
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard1"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "nidBacks")}
									showUploadList={false}
									value={nidBacksName}
									style={{ marginTop: "10px" }}
								/>
								{nidBacksName ? nidBacksName : ""}
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									required

									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Currency"
									fullWidth={true}
									name="EditCurrency"
									style={{ marginTop: "10px" }}
									// value={currency}
									value={editCurrency || ""}
									// onChange={(e) => onInputChange(e)}
									onChange={handleChange}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									<MenuItem value="BDT">BDT</MenuItem>
									{/* {adminCurrencyList.success &&
                                    adminCurrencyList.data.currencyList.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))} */}
								</TextField>
								{/* </div> */}
								{/* <div style={{ marginTop: "1.5rem" }}> */}

								<TextField
									required
									size="small"
									style={{ marginTop: "10px" }}
									color="primary"
									autoFocus={true}
									label="Address"
									fullWidth={true}
									name="GetAddress"
									value={getAddress}
									onChange={handleChange}

								// onChange={(e) => onInputChange(e)}
								// onChange={(e) => onInputChange(e, "both")}
								/>

								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									style={{ marginTop: "10px" }}
									label="Country"
									fullWidth={true}
									name="EditCountry"
									// value={country}
									value={editCountry || ""}
									// onChange={(e) => onInputChange(e)}
									onChange={handleChange}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									{countries.map((value) => (
										<MenuItem value={value.label}>{value.label}</MenuItem>
									))}
								</TextField>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									style={{ marginTop: "10px" }}
									label="Division"
									fullWidth={true}
									name="EditDivision"
									// value={country}
									onChange={handleChange}
									value={editDivision || ""}

								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select Division" selected="Select Division">
										Select Divison
									</MenuItem>
									{setDivisionList.success &&
										setDivisionList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                    <MenuItem value={value.label + value.dial_code}>
                                        {value.label}
                                    </MenuItem>
                                ))} */}
								</TextField>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									style={{ marginTop: "10px" }}
									label="District"
									fullWidth={true}
									name="EditDistrict"
									onChange={handleChange}
									// value={country}
									value={editDistrict || ""}

								// defaultValue={"Select District" || editDistrict}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select District" selected="Select District">
										Select District
									</MenuItem>
									{setDistrictList.success &&
										setDistrictList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                    <MenuItem value={value.label + value.dial_code}>
                                        {value.label}
                                    </MenuItem>
                                ))} */}
								</TextField>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									style={{ marginTop: "10px" }}
									label="Select Thana/Upazilla"
									fullWidth={true}
									name="EditThana"
									onChange={handleChange}
									value={editThana || ""}

								// value={country}
								// value={"Select Thana/Upazilla" || editThana}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Thana/Upazilla"
										selected="Select Thana/Upazilla"
									>
										Select Thana/Upazilla
									</MenuItem>
									{setThanaList.success &&
										setThanaList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}

								</TextField>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									style={{ marginTop: "10px" }}
									label="Select Union/Ward"
									fullWidth={true}
									name="EditUnion"
									// value={country}
									onChange={handleChange}
									value={editUnion || ""}

								// value={"Select Union/Ward" || editUnion}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Thana/Upazilla"
										selected=" Select Union/Ward"
									>
										Select Union/Ward
									</MenuItem>
									{setUnionList.success &&
										setUnionList.data.list.map((x) => (
											<MenuItem value={x.name}>{x.name}</MenuItem>
										))}
									{/* {countries.map((value) => (
                                    <MenuItem value={value.label + value.dial_code}>
                                        {value.label}
                                    </MenuItem>
                                ))} */}
								</TextField>
							</DialogContent>
							<DialogActions>
								<CustomButton
									style={{
										// backgroundColor: "#fff",
										color: "white"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</CustomButton>
								<CustomButton
									style={{
										// backgroundColor: "#00b9f5",
										color: "white",
										textAlign: "center"
									}}
									variant="contained"
									// onClick={handleClose}
									onClick={updateDetailsCustomerFunc}
								>
									Save
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}
				<div className={classes.root}>
					<Dialog
						open={editPassOpen}
						onClose={handleClose1}
						style={{ width: "100%" }}
					>
						<DialogTitle>Change Password</DialogTitle>
						<DialogContent>
							{/* <FormControl className={clsx(classes.margin, classes.textField)} variant="filled">
                                <InputLabel htmlFor="filled-adornment-password">New Password</InputLabel>
                                <FilledInput
                                    id="filled-adornment-password"
                                    name="newPassword"
                                    type={values.showPassword ? 'text' : 'password'}
                                    value={values.newPassword}
                                    onChange={handleChange('newPassword')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                // onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <FormControl className={clsx(classes.margin, classes.textField)} variant="filled">
                                <InputLabel htmlFor="filled-adornment-password">Confirm Password</InputLabel>
                                <FilledInput
                                    id="filled-adornment-password"
                                    name="confirmPassword"
                                    type={confirmPass.showConfirmPassword ? 'text' : 'password'}
                                    value={confirmPass.confirmPassword}
                                    onChange={handleChange('confirmPassword')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowConfirmPassword}
                                                // onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {confirmPass.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl> */}

							<FormControl className={clsx(classes.margin, classes.textField)}>
								<InputLabel htmlFor="standard-adornment-password">
									New Password
								</InputLabel>
								<Input
									id="standard-adornment-password"
									helperText="Please select your currency"
									type={changePassword ? "password" : "text"}
									// id="newPassword"
									name="newPassword"
									autoComplete="current-password"
									variant="standard"
									value={newPassword}
									onChange={(e) => onInputChange(e, "both")}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												// onClick={() => {
												//     setChangePassword(changeIcon)
												// }}
												onClick={handleClickShowPassword}
											// onMouseDown={handleMouseDownPassword}
											>
												{changePassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
							<br />
							<FormControl className={clsx(classes.margin, classes.textField)}>
								<InputLabel htmlFor="standard-adornment-password">
									Confirm Password
								</InputLabel>
								<Input
									id="standard-adornment-password"
									label="ConfirmPassword"
									type={confirmPass ? "password" : "text"}
									// id="newPassword"
									name="confirmPassword"
									autoComplete="current-password"
									variant="standard"
									value={confirmPassword}
									onChange={(e) => onInputChange(e, "both")}
									// error={
									//     newPassword &&
									//         newPassword !== confirmPassword &&
									//         confirmPassword ? (
									//         <p
									//             className="passwordNotMatch"
									//             style={{ color: "red" }}
									//         >
									//             {"Password did not match"}
									//         </p>
									//     ) : (
									//         ""
									//     )
									// }
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												// onClick={() => {
												//     setConfirmPassword(changeIconConfirm)
												// }}
												onClick={handleClickConfirmShowPassword}
											>
												{confirmPass ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									textAlign: "center"
								}}
								variant="contained"
								// onClick={handleClose1}
								// onClick={setChangeMasterPassword}
								onClick={setChangeDsrMasterPasswordReq}
							>
								Save Changes
							</CustomButton>
							<CustomButton
								style={{
									backgroundColor: "#fff",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose1}
							>
								Cancel
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={openBlockdsr} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>
							Do you really want to Block this DSR deatils?
						</DialogTitle>
						<DialogActions className="p-3">
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={blockDsrMasterRecords}
							>
								Yes
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={openUnBlockdsr} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>
							Do you really want to Unblock this DSR deatils?
						</DialogTitle>
						<DialogActions className="p-3">
							<CustomButton
								style={{
									// backgroundColor: "#fff",
									// color: "#000",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={blockDsrMasterRecords}
							>
								Yes
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>
			{getChangeDsrMasterPasswordArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getChangeDsrMasterPasswordArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{getChangeDsrMasterPasswordArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getChangeDsrMasterPasswordArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{getChangeDsrMasterPasswordArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getChangeDsrMasterPasswordArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{/* <div>
                <Dialog open={notificationBlockDsrOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <Button
                            style={{
                                backgroundColor: "#fff",
                                color: "#000",
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white",
                            }}
                            variant="contained"
                            onClick={blockDsrMasterRecords}
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div> */}

			{blockDsrMasterArray.status == "success" && (
				<div>
					<Dialog
						open={notificationBlockDsrOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{blockDsrMasterArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{blockDsrMasterArray.status == "Failed" && (
				<div>
					<Dialog
						open={notificationBlockDsrOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{blockDsrMasterArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{blockDsrMasterArray.status == "failed" && (
				<div>
					<Dialog
						open={notificationBlockDsrOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{blockDsrMasterArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateUserInformationPopup.status == "success" && (
				<div>
					<Dialog open={notificationOpenModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserInformationPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateUserInformationPopup.status == "failed" && (
				<div>
					<Dialog open={notificationOpenModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserInformationPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateUserInformationPopup.status == "Failed" && (
				<div>
					<Dialog open={notificationOpenModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserInformationPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default DealerDsrMaster;
